import { render, staticRenderFns } from "./cardrecord.vue?vue&type=template&id=5bd530b8&"
import script from "./cardrecord.vue?vue&type=script&lang=js&"
export * from "./cardrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports